import type { CMSConfig } from '#types/config/components/cms'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    root: 'space-y-4',
    ul: 'space-y-2'
  }
} satisfies RecursivePartial<CMSConfig['megaMenuL2Desktop']>
